<template>
  <div class="review-container__wrapper">
    <div class="review-container">
      <div
        style="margin-top: 60px"
        v-if="!storeData.cover_url"
        v-loading="true"
      />
      <div v-else>
        <img
          v-if="storeData.cover_url"
          :src="storeData.cover_url"
          class="store-cover"
          width="100%"
          :height="imgHeight"
        />
      </div>
      <span class="review-content"
        >Hi, {{ ticketData ? ticketData.customer.full_name : "" }} How would you
        rate your most recent service?</span
      >
      <div class="rating-container">
        <div class="star-container">
          <div
            v-for="(item, index) in ratingStar"
            :key="index"
            class="star normal-button"
            @click="ratingNumber = index + 1"
          >
            <img v-if="item" src="@/assets/star_fill.svg" />
            <img v-else src="@/assets/star.svg" />
          </div>
        </div>
      </div>
      <div
        class="complain-container"
        v-if="ratingNumber > 0 && ratingNumber < 4"
      >
        <textarea
          class="review-area"
          placeholder="Please share your feedback to help us getting better"
          v-model="reviewContent"
        />
        <input
          v-if="ticketId == ''"
          type="tel"
          class="review-input"
          placeholder="Phone"
          v-model="reviewPhone"
        />
        <input
          v-if="ticketId == ''"
          type="email"
          class="review-input"
          placeholder="Email (optional)"
          v-model="reviewEmail"
        />
        <div v-else style="height: 40px" />
        <div class="btn-submit normal-button" @click="onSubmitReview">
          <span>Submit</span>
        </div>
      </div>
      <div class="review-google-container" v-if="ratingNumber >= 4">
        <div class="login-google-button normal-button" @click="loginGoogle">
          <img src="@/assets/ic_google.svg" />
          <span class="login-text">Sign in with Google</span>
        </div>
        <span class="review-google-description">
          Sign in with your Google Account to write a
          <span class="bold-text">review on Google</span>, Your review enters
          you in for a chance to win a
          <el-tooltip class="item" placement="top">
            <div
              slot="content"
              style="width: 330px; line-height: 22px; font-size: 14px"
            >
              <span
                >Win a $250 gift card.<br /><br />Thanks so much for visiting
                our salon. How did we do? Please leave us a review to let us
                know. Your review not only helps us, it helps other potential
                customers. It takes only a moment and would mean the world to
                us.<br /><br />Your review enters you in for a chance to win a
                $250 gift card. Four lucky winners will be announced at the end
                of each quarter (March 31st, June 30th, September 30th &
                December 31st). That's 16 winners in total for the year! Are you
                feeling lucky? Enter below now.</span
              >
            </div>
            <span class="bold-text underline-text highlight-text"
              >$250 gift card</span
            >
          </el-tooltip>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getDisplayName, findTicketById, addReview } from "@/api/home";
import { Message } from "element-ui";
export default {
  data() {
    return {
      ratingNumber: 0,
      storeData: {},
      storeName: "",
      ticketId: "",
      windowWidth: Math.min(600, window.innerWidth),
      ticketData: null,
      reviewContent: "",
      reviewPhone: "",
      reviewEmail: "",
      giftContent: `Win a $250 gift card\nThanks so much for visiting our salon. How did we do? Please leave us a review to let us know. Your review not only helps us, it helps other potential customers. It takes only a moment and would mean the world to us.\nYour review enters you in for a chance to win a $250 Vip spa gift card. Four lucky winners will be announced at the end of each quarter (March 31st, June 30th, September 30th & December 31st). That's 16 winners in total for the year! Are you feeling lucky? Enter below now.`,
    };
  },
  methods: {
    async onSubmitReview() {
      const body = {
        review_score: this.ratingNumber,
        review_content: this.reviewContent,
        store_name: this.storeName,
        phone_number: this.reviewPhone,
        email: this.reviewEmail
      };
      if (this.ticketId) {
        body.ticket_id = this.ticketId;
        body.user_id = this.ticketData.customer.user_id;
      }
      await addReview(body);
      Message({
        message: "Thank you for your review",
        type: "success",
        duration: 2 * 1000,
        onClose: () => {
          // window.location.href = "https://www.avnailscolumbus.com/";
          window.location.href = this.storeData.store_url || "https://www.avnailscolumbus.com/";
        },
      });
    },
    async messageReceive(event) {
      if (event.origin == "https://accounts.google.com") {
        const { authResult } = JSON.parse(event.data).params;
        const body = {
          review_score: this.ratingNumber,
          google_auth: {
            id_token: authResult.id_token,
          },
          store_name: this.storeName,
          phone_number: this.reviewPhone,
        };
        if (this.ticketId) {
          body.ticket_id = this.ticketId;
          body.user_id = this.ticketData.customer.user_id;
        }
        await addReview(body);
        window.location.href =
          this.storeData.google_review_url || "https://www.google.com/";
      }
    },
    loginGoogle() {
      let top = window.screen.height - 600;
      top = top > 0 ? top / 2 : 0;

      let left = window.screen.width - 600;
      left = left > 0 ? left / 2 : 0;
      // const redirect_uri = "localhost:8080";
      // const scheme = "http";
      const redirect_uri = process.env.VUE_APP_BASE_URL;
      const scheme = "https";
      window.open(
        `https://accounts.google.com/o/oauth2/auth/oauthchooseaccount?redirect_uri=storagerelay%3A%2F%2F${scheme}%2F${redirect_uri}%3Fid%3Dauth669654&response_type=code%20permission%20id_token&scope=profile%20email%20openid&openid.realm&client_id=107185410564-bdf4qb8qos09mkbpues94mfl13skomrs.apps.googleusercontent.com&ss_domain=${scheme}%3A%2F%2F${redirect_uri}&access_type=offline&include_granted_scopes=true&prompt=consent&origin=${scheme}%3A%2F%2F${redirect_uri}&gsiwebsdk=2&flowName=GeneralOAuthFlow`,
        "popup",
        "width=600,height=600" + ",top=" + top + ",left=" + left
      );
    },
    onResize() {
      this.windowWidth = Math.min(600, window.innerWidth);
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    technician() {
      if (!this.ticketData || this.ticketData.user_assign.length == 0) {
        return "Anyone";
      }
      return this.ticketData.user_assign
        .map((u) => u.user.full_name)
        .join(", ");
    },
    ratingStar() {
      let res = [false, false, false, false, false];
      res = res.map((_, index) => index < this.ratingNumber);
      return res;
    },
    imgHeight() {
      return this.windowWidth / 3;
    },
    device() {
      return this.$store.state.app.device;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    dialogWidth() {
      if (this.isMobile) return "100%";
      return "600px";
    },
  },
  created() {
    this.ticketId = this.$route.query.ticket_id || "";
    if (this.ticketId) {
      findTicketById(this.ticketId).then((res) => {
        this.ticketData = res;
        this.storeName = res.store;
        getDisplayName(this.storeName).then((res) => {
          this.storeData = res;
        });
      });
    } else {
      this.storeName = this.$route.query.storename;
      getDisplayName(this.storeName).then((res) => {
        this.storeData = res;
      });
    }
    window.removeEventListener("message", this.messageReceive);
    window.addEventListener("message", this.messageReceive, false);
  },
};
</script>

<style lang="scss">
.review-container {
  .el-dialog__close {
    font-size: 30px !important;
  }
}
</style>

<style lang="scss" scoped>
.review-container__wrapper {
  padding-left: calc(50% - 300px);
  padding-right: calc(50% - 300px);
}
.store-cover {
  object-fit: cover;
}
.review-container {
  display: flex;
  flex-direction: column;
  color: #222222;
  padding-left: 0px;
  padding-right: 0px;
  width: 100%;
  height: 100vh;
  background: #fff9ec;
  overflow: auto;
  .review-content {
    font-weight: 600;
    font-size: 20;
    line-height: 24px;
    color: black;
    align-self: center;
    padding: 40px 30px 0 30px;
  }
  .rating-container {
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    align-items: center;
    justify-content: center;
    .star-container {
      display: flex;
      align-items: center;
      .star {
        margin: 0 7.5px;
      }
    }
    .ticket-info {
      font-weight: 600;
      font-size: 14px;
      color: black;
    }
  }
  .review-google-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    margin-top: 60px;
    .login-google-button {
      width: 335px;
      height: 60px;
      border-radius: 5px;
      background-color: white;
      display: flex;
      align-items: center;
      padding: 0 30px;
      .login-text {
        font-weight: 600;
        font-size: 18px;
        color: #222222;
        margin-left: 21px;
      }
    }
    .review-google-description {
      font-weight: 600;
      color: #5f5f5f;
      font-size: 14px;
      line-height: 23px;
      padding: 0 20px;
      margin-top: 30px;
    }
    .bold-text {
      font-weight: 700;
      color: #222222;
    }
    .underline-text {
      text-decoration: underline;
    }
    .highlight-text {
      font-size: 18px;
    }
    .content-gift {
      line-height: 29px;
    }
  }
  .complain-container {
    display: flex;
    flex-direction: column;
    .review-area {
      border: none;
      margin: 50px 32px 0px 32px;
      padding: 20px;
      height: 130px;
      resize: none;
      font-weight: 500;
      font-size: 16px;
    }
    .review-input {
      border: none;
      margin: 20px 32px 0px 32px;
      padding: 20px;
      resize: none;
      font-weight: 500;
      font-size: 16px;
    }
    .btn-submit {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      background-color: #2e2323;
      border-radius: 5px;
      margin: 40px 38px;
      color: white;
      font-size: 18px;
      font-weight: 600;
    }
  }
}
@media only screen and (max-width: 600px) {
  .review-container {
    padding-left: 0;
    padding-right: 0;
  }
  .review-container__wrapper {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>